import { useContext } from 'react';
import { ConfigContext } from '../ConfigProvider/ConfigProvider';

export const useAppName = () => useContext(ConfigContext).appName;
